import { Component, OnInit } from '@angular/core';

import { AppService } from '../../services/app.service';
import { ITableColumn } from '../../shared/table/table.component';
import { LessonObservationService } from '../../services/lesson-observation.service';
import { ILessonObservationListItem } from '../../models/LessonObservation';
import { MessageService } from '../../services/message.service';

@Component({
    selector: 'app-lesson-observation-list',
    templateUrl: './list.component.html'
})
export class LessonObservationListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: LessonObservationService,
        private messages: MessageService
    ) { }

    items: ILessonObservationListItem[] = [];

    readonly canPromote = this.app.currentUser.rights.includes('LESSON_OBSERVATION.PROMOTE');
    readonly canApprove = this.app.currentUser.rights.includes('LESSON_OBSERVATION.APPROVE');
    readonly canEdit = this.app.currentUser.rights.includes('LESSON_OBSERVATION.EDIT');

    readonly columns: ITableColumn[] = [
        { property: 'Subject', label: 'lessonObservation_lblEvent', sorts: true },
        { property: 'Date', label: 'lessonObservation_lblDate', sorts: true, type: 'date', cssClass: 'hidden-md-down' },
        { property: 'Location', label: 'lessonObservation_lblLocation', cssClass: 'hidden-md-down' },
        { property: 'Status', label: 'lessonObservation_lblStatus', sorts: true, cssClass: 'hidden-sm-down' },
        { width: '1px' }
    ];

    page: number = 1;
    readonly pageSize: number = 10;
    total: number = 0;
    sortBy: string;
    sortDir: 'asc' | 'desc';
    info: string;

    ngOnInit() {
        this.app.addLoading(this.messages.getText('LESSON_OBSERVATION_INFO')).subscribe(data => {
            this.info = data.length ? data[0].Text : undefined;
        });

        this.fetch();
    }

    delete(item: ILessonObservationListItem) {
        this.app.confirm(this.app.translate('confirmItemDelete'), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(item.Id)).subscribe(() => {
                this.fetch();
            });
        });
    }

    checkDelete(item: ILessonObservationListItem) {
        return this.canEdit && item.Status == 'Draft';
    }

    onPage(event: number) {
        this.page = event;
        this.fetch();
    }

    onSort(event: { sortBy: string, sortDir: 'asc' | 'desc' }) {
        this.sortBy = event.sortBy;
        this.sortDir = event.sortDir;
        this.fetch();
    }

    private fetch() {
        this.app.addLoading(this.service.get({
            page: this.page,
            size: this.pageSize,
            dir: this.sortDir,
            sort: this.sortBy
        })).subscribe(data => {
            this.items = data.items;
            this.total = data.total;
        });
    }
}
